// @dynamic-i18n-keys
// popup.discounts.audience.var.*
import React from 'react';
import { useTranslation } from 'react-i18next';
import { PapiSellerDiscount } from '@wix/da-papi-types';
import { ModalRoot } from '@wix/da-ds/pkg/modals/base';
import Popover from '@wix/da-ds/pkg/popovers/dsPresets/Popover';
import s from './DiscountsPopup.scss';

interface Props {
  className?: string;
  isOpen?: boolean;
  onRequestClose?: () => void;
  discounts?: PapiSellerDiscount[];
}

const DiscountLineItem: React.FC<{ discount: PapiSellerDiscount }> = ({
  discount,
}) => {
  const { t } = useTranslation();
  if (discount?.amount?.percent) {
    return (
      <span>
        {discount.amount.percent}% {t('common.off')}{' '}
        {t(`popup.discounts.audience.var.${discount.audience}`)}
      </span>
    );
  }
};

const DiscountsPopup: React.FC<Props> = ({
  isOpen = false,
  onRequestClose,
  discounts,
}) => {
  const { t } = useTranslation();
  return (
    <ModalRoot
      className={s['root']}
      isOpen={isOpen}
      hasCloseButton={false}
      shouldCloseOnOverlayClick
    >
      <Popover
        className={s['popover']}
        heading={t('popup.discounts.title')}
        content={
          <div className={s['content']}>
            <ul className={s['list']}>
              {discounts?.map(discount => (
                <li key={discount.discountId} className={s['list-item']}>
                  <DiscountLineItem discount={discount} />
                </li>
              ))}
            </ul>
          </div>
        }
        onCloseClick={onRequestClose}
      />
    </ModalRoot>
  );
};
DiscountsPopup.displayName = 'DiscountsPopup';

export default DiscountsPopup;
